import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { IMonthResponse, INoteHead } from '../models/release-note.model';
import { ReleaseNoteService } from '../Services/release-note.service';
import { HeaderService } from '../Services/header.service';
import { ApplicationService } from '../Services/application.service';

export class Month {
  monthName: string = null;
  monthYear: string = null;
  releases: number;
  latestVersion: string = null;
  lastReleaseDate: Date = null;

  constructor(public mon: number = null, public yr: number = null) {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];

    this.monthName = monthNames[mon - 1];
    this.monthYear = `${mon}${yr}`;
    this.releases = 1;
  }
}

@Component({
  selector: 'md-grid',
  templateUrl: './month-dashboard.component.html',
  styleUrls: ['../app.component.scss']
})
export class MonthDashboardComponent implements OnInit, OnDestroy {

  searchSub: Subscription;
  appSub: Subscription;
  constructor(private releaseNoteService: ReleaseNoteService, private route: ActivatedRoute, private headerService: HeaderService,
              private applicationService: ApplicationService, private router: Router) { }

  appName: string = this.route.snapshot.paramMap.get('appName');
  appID: number = +this.route.snapshot.paramMap.get('appID');
  errorMessage = '';

  months: Month[];
  older: Month[];
  dates: string[];
  isCollapsed: boolean;

  buildMonthArrays(releaseNotes: IMonthResponse): void {
    const filtered = releaseNotes.data;

    this.months = [];
    this.older = [];
    this.dates = [];

    filtered.sort((a, b) =>
    (a.releaseDate < b.releaseDate) ? 1 : (a.releaseDate > b.releaseDate) ? -1 :
      (a.versionNum < b.versionNum) ? 1 : (a.versionNum > b.versionNum) ? -1 :
        0);

    for (const head of filtered) {
      const dt = new Date(head.releaseDate);
      const m = dt.getMonth() + 1;
      const y = dt.getFullYear();

      if (this.dates.indexOf(`${m}-${y}`) < 0) {
        this.addNewMonthtoCollection(m, y, head);
      } else {
        this.updateExistingMonth(m, y);
      }
    }
  }

  private updateExistingMonth(m: number, y: number) {
    let mo = this.months.find(x => x.monthYear === `${m}${y}`);
    if (!mo) {
      mo = this.older.find(x => x.monthYear === `${m}${y}`);
    }
    ++mo.releases;
  }

  private addNewMonthtoCollection(m: number, y: number, head: INoteHead) {
    const mo = new Month(m, y);
    mo.lastReleaseDate = head.releaseDate;
    mo.latestVersion = head.versionNum;

    const lastYear = (new Date()).getFullYear() - 1;
    if (this.months.length < 12 && (y > lastYear || (y === lastYear && m > (new Date().getMonth() + 1)))) {
      this.months.push(mo);
    } else {
      this.older.push(mo);
    }

    this.dates.push(`${m}-${y}`);
  }

  onSearch(term: string) {
    this.releaseNoteService.getMonths(this.appID, term).subscribe({
      next: releaseNotes => {
        this.buildMonthArrays(releaseNotes);
      },
      error: err => this.errorMessage = err
    });
  }

  ngOnInit(): void {
    this.applicationService.checkApplication(this.appID, this.appName).then((resp) => {
      if (!resp) {
        this.router.navigate(['applications']);
      } else {
        // this.isCollapsed = true;
        this.searchSub = this.headerService.searchCommand$.subscribe((term) => {
          this.onSearch(term);
        });

        this.headerService.setBreadcrumbs(this.appName, this.appID);
        this.onSearch(this.headerService.searchTerm);
      }
    });
  }

  public ngOnDestroy() {
    if (this.searchSub !== undefined) {
      this.searchSub.unsubscribe();
    }
  }
}
